// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__5Fo9r","signatureButtonsRight":"ModalSign_signatureButtonsRight__3R0n0"};